// P5 T4 — /api/notifications client. Paths WITHOUT the /api prefix
// (@/lib/api-client adds it). Shapes mirror the api routes exactly.
import { api } from "@/lib/api-client";

export interface NotificationRecord {
  id: string;
  message: string;
  targetRole: string | null;
  targetUserId: string | null;
  documentId: string | null;
  batchId: string | null;
  sourceRuleId: string | null;
  sourceRuleName: string | null;
  readAt: string | null;
  createdAt: string;
}

export const notificationsApi = {
  list: (opts?: { unread?: boolean; limit?: number }) => {
    const q = new URLSearchParams();
    if (opts?.unread) q.set("unread", "1");
    if (opts?.limit) q.set("limit", String(opts.limit));
    const qs = q.toString();
    return api.get<{ notifications: NotificationRecord[] }>(
      `/notifications${qs ? `?${qs}` : ""}`,
    );
  },
  markRead: (id: string) => api.post<{ ok: true }>(`/notifications/${id}/read`, {}),
  markAllRead: () => api.post<{ count: number }>("/notifications/read-all", {}),
};
